class HbsHastasividengeDTO {
    id: number = null;
    hastaservisId?: number = null;
    tarih?: string = null;
    saatbaslangic?: string = "";
    saatbitis?: string = "";
    alinanDamaryol?: number = null;
    alinanOral?: number = null;
    alinanNgt?: number = null;
    cikarilanIdrar?: number = null;
    cikarilanNgt?: number = null;
    cikarilanGogust?: number = null;
    cikarilanDren?: number = null;
    cikarilanKusma?: number = null;
    cikarilanDiski?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalTarihi?: string = null;
    fkIptalneden?: number = null;
}
export default HbsHastasividengeDTO;